var _stop, _stop2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import { useUniqueInlineId } from '@inline-svg-unique-id/react';
import * as React from "react";
var SvgTriangleBottom = function SvgTriangleBottom(props) {
  var _id = useUniqueInlineId();
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 78,
    height: 72,
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "url(#".concat(_id, ")"),
    d: "M27.38 68.887c18.652-9.39 38.496-19.389 41.859-21.081 3.363-1.693 7.228-5.079 8.25-10.95.992-5.69-1.983-12.318-6.736-13.979C66 21.217 11.75 2.497 8.268 1.201 4.788-.095-1.576-.059-7.209 5.672c-5.632 5.73-4.353 11.6-3.09 14.729 1.262 3.128 17.326 38.468 19.027 42.243 1.7 3.776 3.68 6.543 6.842 7.702 4.016 1.471 7.028.95 11.81-1.459Z"
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: _id,
    x1: 3.556,
    x2: 49.79,
    y1: 61.086,
    y2: 4.984,
    gradientUnits: "userSpaceOnUse"
  }, _stop || (_stop = /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17D3FF"
  })), _stop2 || (_stop2 = /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00EA90"
  })))));
};
export default SvgTriangleBottom;